import React from "react";

const AllMessages = () => {
  return (
    <div>
      <h1>AllMessages</h1>
    </div>
  );
};

export default AllMessages;
